import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqItems = [
    {
      question: "Can we do overnight Traffic Control Operations?",
      answer: [
        "• Emergency response teams available 24/7 with guaranteed 2-hour arrival time in service areas",
        "• Dedicated dispatch center with real-time tracking of response units and equipment"
      ]
    },
    {
      question: "How do we schedule Traffic Control with you?",
      answer: [
        "• Full range of DOT-certified traffic control equipment including signs, barriers, and message boards",
        "• Specialized equipment available including arrow boards, traffic cones, and temporary barriers"
      ]
    },
    {
      question: "Do we need a Traffic Control Plan (TCP)?",
      answer: [
        "• Custom traffic control plans designed to meet all local and state regulations",
        "• Expert team available for both small-scale road work and major construction projects"
      ]
    },
    {
      question: "Will our project require Traffic Control?",
      answer: [
        "• Standard projects require 48-72 hours advance booking for optimal equipment availability",
        "• Large-scale projects recommended to book 1-2 weeks ahead for comprehensive planning"
      ]
    },
    {
      question: "Do we provide Certified Flaggers?",
      answer: [
        "• Comprehensive coverage across seven states: Arizona, California, Colorado, Nevada, New Mexico, Texas, and Utah",
        "• Strategic locations enabling quick response times and efficient service delivery"
      ]
    }
  ];

  return (
    <section className="bg-white py-16">
      <div className="container max-w-5xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Frequently Asked Questions</h2>
        <div className="relative">
          <Accordion type="single" collapsible className="space-y-4">
            {faqItems.map((item, index) => (
              <div key={index} className="relative">
                <AccordionItem
                  value={`item-${index + 1}`}
                  className="border-0 bg-gray-100 overflow-hidden group relative"
                >
                  <AccordionTrigger 
                    className="px-4 py-5 relative z-10 transition-all duration-200 
                    text-black 
                    [&[data-state=open]]:text-orange-700 
                    group-hover:text-orange-700 text-lg"
                  >
                    {item.question}
                  </AccordionTrigger>
                  <div className="text-content relative z-10">
                    <AccordionContent 
                      className="px-4 pb-5 text-black transition-all duration-200
                      group-hover:text-orange-700
                      group-data-[state=open]:text-orange-700"
                    >
                      {item.answer.map((line, i) => (
                        <div key={i} className="mb-2 last:mb-0">
                          {line}
                        </div>
                      ))}
                    </AccordionContent>
                  </div>
                  
                  <div 
                    className="absolute inset-0 bg-gray-100 transition-all duration-200 -z-0 
                    group-hover:bg-orange-100 
                    [.group[data-state=open]_&]:bg-orange-100"
                  />
                </AccordionItem>
              </div>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
